<template>
  <div id="guides-detail">
    <h2>상단 본문 영역</h2>
    <div class="row">
      <div class="col-md-12">
        <ckeditor v-model="description" :editor="editor" :config="editorConfig" @ready="attachInspector"></ckeditor>
      </div>
    </div>
    <hr />

    <h2 class="mt-5">카드 영역</h2>
    <div>
      <guide-item-editor
        v-for="editorId in editorIds"
        :id="editorId"
        :key="editorId"
        :items="['bold', 'bulletedList', 'link', '|', 'undo', 'redo']"
      >
      </guide-item-editor>
    </div>

    <div class="col-md-12 pr-0">
      <div class="form-inline form-group pull-right">
        <input
          id="add-part"
          type="button"
          class="btn btn-primary add-part"
          value="추가"
          @click="addGuideItemEditor()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import inlineEditorConfig from '../mixins/InlineEditorConfig';
import helpers from '../helpers/helpers';

export default {
  mixins: [inlineEditorConfig],
  props: ['guideId', 'initialGuideDescription', 'initialGuideItems'],
  data() {
    return {
      editorIds: [],
      numberOfGuideItemsIncludingDeletedGuideItems: 0,
    };
  },
  computed: {
    description: {
      get() {
        return this.$store.state.guideEditor.guideDescription;
      },
      set(value) {
        this.commitUpdateGuideEditorDescriptionDebounced(value);
        EventBus.$emit('setIsSavedGuide', false);
      },
    },
  },
  created() {
    this.initGuideEditor();
    this.$on('deleteGuideItem', this.deleteGuideItem);
    this.$on('upGuideItem', this.upGuideItem);
    this.$on('downGuideItem', this.downGuideItem);
  },
  methods: {
    initGuideEditor() {
      this.$store.commit('createGuideDescription', this.initialGuideDescription);

      for (let initialGuideItem of this.initialGuideItems) {
        let guideItem = this.createGuideItemFromInitialGuideItem(initialGuideItem);
        this.$store.commit('createGuideItemEditor', guideItem);
        this.editorIds.push(guideItem.editorId);
      }
    },

    addGuideItemEditor() {
      let guideItem = this.createGuideItem(null, '', '', 1);
      this.$store.commit('createGuideItemEditor', guideItem);
      this.editorIds.push(guideItem.editorId);
      EventBus.$emit('setIsSavedGuide', false);
    },

    createGuideItemFromInitialGuideItem(initialGuideItem) {
      return this.createGuideItem(
        initialGuideItem.id,
        initialGuideItem.title,
        initialGuideItem.description,
        initialGuideItem.type,
        initialGuideItem.item_id,
      );
    },

    createGuideItem(id, title, description, type, itemId) {
      let guideItem = {};
      guideItem.editorId = this.generateEditorId();
      guideItem.id = id;
      guideItem.title = title;
      guideItem.description = description;
      guideItem.relativeOrder = this.numberOfGuideItemsIncludingDeletedGuideItems++;
      guideItem.type = type;
      guideItem.itemId = itemId;

      return guideItem;
    },

    generateEditorId() {
      return Math.random().toString(36).substring(7);
    },

    deleteGuideItem(editorIdToDelete) {
      let indexToDelete = this.editorIds.indexOf(editorIdToDelete);
      if (indexToDelete >= 0) {
        this.editorIds.splice(indexToDelete, 1);
      }
      EventBus.$emit('setIsSavedGuide', false);
      this.$store.commit('deleteGuideItemEditor', editorIdToDelete);
    },

    upGuideItem(editorIdToUp) {
      let indexToUp = this.editorIds.indexOf(editorIdToUp);
      if (indexToUp > 0) {
        EventBus.$emit('setIsSavedGuide', false);
        let indexToDown = indexToUp - 1;
        let editorIdToDown = this.editorIds[indexToDown];
        this.swapGuideItems(indexToDown, indexToUp, editorIdToUp, editorIdToDown);
      }
    },

    downGuideItem(editorIdToDown) {
      let indexToDown = this.editorIds.indexOf(editorIdToDown);
      if (indexToDown >= 0 && indexToDown < this.editorIds.length - 1) {
        EventBus.$emit('setIsSavedGuide', false);
        let indexToUp = indexToDown + 1;
        let editorIdToUp = this.editorIds[indexToUp];
        this.swapGuideItems(indexToDown, indexToUp, editorIdToUp, editorIdToDown);
      }
    },

    swapGuideItems(indexToDown, indexToUp, editorIdToUp, editorIdToDown) {
      this.commitSwapGuideItemEditorRelativeOrders(editorIdToUp, editorIdToDown);
      this.swapGuideItemEditorIds(indexToDown, editorIdToUp, editorIdToDown);
    },

    commitSwapGuideItemEditorRelativeOrders(editorIdToUp, editorIdToDown) {
      this.$store.commit({
        type: 'swapGuideItemEditorRelativeOrders',
        editorIdA: editorIdToUp,
        editorIdB: editorIdToDown,
      });
    },

    swapGuideItemEditorIds(indexToDown, editorIdToUp, editorIdToDown) {
      this.editorIds.splice(indexToDown, 2, editorIdToUp, editorIdToDown);
    },

    commitUpdateGuideEditorDescriptionDebounced: _.debounce(function (value) {
      this.$store.commit('updateGuideEditorDescription', helpers.replaceSmartQuotes(value));
    }, 100),
  },
};
</script>
